import React from "react";
import "../../assets/css/components/skeletoloadig/HelpSupportSkeleton.css";

const HelpSupportSkeleton = () => {
  return (
    <div className="hs-skeleton-page">

      {/* Header */}
      <div className="hs-skeleton-header shimmer">
        <div className="hs-skeleton-back"></div>

        <div className="hs-skeleton-header-center">
          <div className="hs-skeleton-header-title"></div>
        </div>

        <div className="hs-skeleton-header-icon"></div>
      </div>

      <div className="hs-skeleton-body">

        {/* Filter Tabs */}
        <div className="hs-skeleton-filters">
          <div className="hs-skeleton-filter shimmer"></div>
          <div className="hs-skeleton-filter shimmer"></div>
          <div className="hs-skeleton-filter shimmer"></div>
          <div className="hs-skeleton-filter shimmer"></div>
        </div>

        {/* Cards */}
        <div className="hs-skeleton-list">
          {[1, 2, 3].map((item) => (
            <div className="hs-skeleton-card shimmer" key={item}>

              <div className="hs-skeleton-top">

                <div className="hs-skeleton-left">

                  <div className="hs-skeleton-icon"></div>

                  <div className="hs-skeleton-content">

                    <div className="hs-skeleton-title"></div>

                    <div className="hs-skeleton-tags">
                      <div className="hs-skeleton-tag"></div>
                      <div className="hs-skeleton-tag"></div>
                    </div>

                  </div>

                </div>

                <div className="hs-skeleton-status"></div>

              </div>

              <div className="hs-skeleton-description"></div>
              <div className="hs-skeleton-description short"></div>

              <div className="hs-skeleton-footer">
                <div className="hs-skeleton-message"></div>
                <div className="hs-skeleton-button"></div>
              </div>

            </div>
          ))}
        </div>

      </div>

    </div>
  );
};

export default HelpSupportSkeleton;